import { produce } from "immer";
import {
  FETCH_OBS_SCHEDULES,
  FETCH_OBS_SCHEDULES_SUCCESS,
  FETCH_OBS_SCHEDULES_FAILURE,
  ADD_OBS_SCHEDULE,
  ADD_OBS_SCHEDULE_SUCCESS,
  ADD_OBS_SCHEDULE_FAILURE,
  EDIT_OBS_SCHEDULE,
  EDIT_OBS_SCHEDULE_SUCCESS,
  EDIT_OBS_SCHEDULE_FAILURE,
  DELETE_OBS_SCHEDULE,
  DELETE_OBS_SCHEDULE_SUCCESS,
  DELETE_OBS_SCHEDULE_FAILURE,
  TOGGLE_OBS_SCHEDULE,
  TOGGLE_OBS_SCHEDULE_SUCCESS,
  TOGGLE_OBS_SCHEDULE_FAILURE,
  FETCH_DUE_OBSERVATIONS,
  FETCH_DUE_OBSERVATIONS_SUCCESS,
  FETCH_DUE_OBSERVATIONS_FAILURE,
  FETCH_DUE_SUMMARY,
  FETCH_DUE_SUMMARY_SUCCESS,
  FETCH_DUE_SUMMARY_FAILURE,
} from "./constants";

export const initialState = {
  schedules: {},
  isFetchingSchedules: false,
  isSubmitting: false,
  isDeleting: false,
  isToggling: false,
  dueObservations: [],
  isFetchingDue: false,
  dueSummary: {},
  isFetchingSummary: false,
};

const ObservationScheduleReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_OBS_SCHEDULES:
        draft.isFetchingSchedules = true;
        break;
      case FETCH_OBS_SCHEDULES_SUCCESS:
        draft.isFetchingSchedules = false;
        draft.schedules = action.payload;
        break;
      case FETCH_OBS_SCHEDULES_FAILURE:
        draft.isFetchingSchedules = false;
        break;
      case ADD_OBS_SCHEDULE:
        draft.isSubmitting = true;
        break;
      case ADD_OBS_SCHEDULE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_OBS_SCHEDULE_FAILURE:
        draft.isSubmitting = false;
        break;
      case EDIT_OBS_SCHEDULE:
        draft.isSubmitting = true;
        break;
      case EDIT_OBS_SCHEDULE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_OBS_SCHEDULE_FAILURE:
        draft.isSubmitting = false;
        break;
      case DELETE_OBS_SCHEDULE:
        draft.isDeleting = true;
        break;
      case DELETE_OBS_SCHEDULE_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_OBS_SCHEDULE_FAILURE:
        draft.isDeleting = false;
        break;
      case TOGGLE_OBS_SCHEDULE:
        draft.isToggling = true;
        break;
      case TOGGLE_OBS_SCHEDULE_SUCCESS:
        draft.isToggling = false;
        break;
      case TOGGLE_OBS_SCHEDULE_FAILURE:
        draft.isToggling = false;
        break;
      case FETCH_DUE_OBSERVATIONS:
        draft.isFetchingDue = true;
        break;
      case FETCH_DUE_OBSERVATIONS_SUCCESS:
        draft.isFetchingDue = false;
        draft.dueObservations = action.payload;
        break;
      case FETCH_DUE_OBSERVATIONS_FAILURE:
        draft.isFetchingDue = false;
        break;
      case FETCH_DUE_SUMMARY:
        draft.isFetchingSummary = true;
        break;
      case FETCH_DUE_SUMMARY_SUCCESS:
        draft.isFetchingSummary = false;
        draft.dueSummary = action.payload;
        break;
      case FETCH_DUE_SUMMARY_FAILURE:
        draft.isFetchingSummary = false;
        break;
      default:
        return state;
    }
  });

export default ObservationScheduleReducer;
